module.exports = __webpack_public_path__ + "b87b9ba532ace76ae9f6edfe9f72ded2.ttf";